require('./brokerHolidayErrorModal.scss');

const PropTypes = require('prop-types');

const React = require('react');

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');

class BrokerHolidayErrorModal extends React.Component{

    constructor(props) {
        super(props);

        this.handleHolidayModalErrorOpen = this.handleHolidayModalErrorOpen.bind(this);
    }

    handleHolidayModalErrorOpen () {
        this.props.onSetHolidayError();
    }

    render() {
        const { holidayErrorState } = this.props;

        return (
            <OKModal
                description="broker-holidaysModalMessage"
                footerType="navigation"
                isOpen={holidayErrorState}
                onCloseCallback={this.handleHolidayModalErrorOpen}
                onPrimaryButtonClick={this.handleHolidayModalErrorOpen}
                primaryButtonText="broker-holidayErrorButtonText"
                title="broker-holidaysModalTitle"
            />
        )
    }
}

BrokerHolidayErrorModal.propTypes = {
    holidayErrorState: PropTypes.bool.isRequired,
    onSetHolidayError: PropTypes.func.isRequired
};

module.exports = BrokerHolidayErrorModal;
